module.exports = __webpack_public_path__ + "static/media/bottom-footer.c2ea30d5.jpg";